@if (rows && rows.length) {
  <div class="review-header">
    <h2>{{ translationService.getReviewAndSubmitProductConnectionsText() }}</h2>

    <div class="review-meta">
      <span class="valid-count">
        <strong>{{ getValidRowCount() }}/{{ getTotalRowCount() }}</strong>
        {{ translationService.getValidRowsText() }}
      </span>

      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="confirm()"
        [disabled]="!isAllValid()"
      >
        <mat-icon>check</mat-icon>
        {{ translationService.getConfirmText() }}
      </button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
    <ng-container matColumnDef="productIdentifier">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getProductIdentifierText() }}
      </th>
      <td mat-cell *matCellDef="let r">{{ r.productIdentifier }}</td>
    </ng-container>

    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getCompanyNameText() }}
      </th>
      <td mat-cell *matCellDef="let r">{{ r.companyName }}</td>
    </ng-container>

    <ng-container matColumnDef="overrideProductSupplier">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getOverrideProductSupplierText() }}
      </th>
      <td mat-cell *matCellDef="let r">
        <span class="status-text">
          {{
            r.overrideProductSupplier
              ? translationService.getYesText()
              : translationService.getNoText()
          }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="overrideComponentSuppliers">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getOverrideComponentSuppliersText() }}
      </th>
      <td mat-cell *matCellDef="let r">
        <span class="status-text">
          {{
            r.overrideComponentSuppliers
              ? translationService.getYesText()
              : translationService.getNoText()
          }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="productResolved">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getProductResolvedText() }}
      </th>
      <td mat-cell *matCellDef="let r">
        <span
          class="status"
          [class.ok]="r.productResolved"
          [class.bad]="!r.productResolved"
        >
          <mat-icon inline>{{
            r.productResolved ? 'check_circle' : 'cancel'
          }}</mat-icon>
          <span class="status-text" [class.invalid-text]="!r.productResolved">
            {{
              r.productResolved
                ? translationService.getOkText()
                : translationService.getFailedText()
            }}
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="companyValid">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getCompanyValidText() }}
      </th>
      <td mat-cell *matCellDef="let r">
        <span
          class="status"
          [class.ok]="r.companyValid"
          [class.bad]="!r.companyValid"
        >
          <mat-icon inline>{{
            r.companyValid ? 'check_circle' : 'cancel'
          }}</mat-icon>
          <span class="status-text" [class.invalid-text]="!r.companyValid">
            {{
              r.companyValid
                ? translationService.getOkText()
                : translationService.getFailedText()
            }}
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="connectedInSupplyChain">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getConnectedText() }}
      </th>
      <td mat-cell *matCellDef="let r">
        <span
          class="status"
          [class.ok]="r.connectedInSupplyChain"
          [class.bad]="!r.connectedInSupplyChain"
        >
          <mat-icon inline>{{
            r.connectedInSupplyChain ? 'check_circle' : 'cancel'
          }}</mat-icon>
          <span
            class="status-text"
            [class.invalid-text]="!r.connectedInSupplyChain"
          >
            {{
              r.connectedInSupplyChain
                ? translationService.getOkText()
                : translationService.getFailedText()
            }}
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="alreadyShared">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getShareStatusText() }}
      </th>
      <td mat-cell *matCellDef="let r">
        <span
          class="status"
          [class.warn]="r.alreadyShared"
          [class.ok]="!r.alreadyShared"
        >
          <mat-icon inline>{{
            r.alreadyShared ? 'info' : 'check_circle'
          }}</mat-icon>
          <span class="status-text">
            {{
              r.alreadyShared
                ? translationService.getAlreadySharedText()
                : translationService.getNotSharedText()
            }}
          </span>
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.invalid-row]="isRowBlocking(row)"
    ></tr>
  </table>

  <mat-paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    showFirstLastButtons
    (page)="onPageChange($event)"
  ></mat-paginator>
}
